import React from 'react';
import ChangePasswordForm from '../../components/auth/change-password-form';

const ChangePassword: React.FunctionComponent<any> = () => {
    return <ChangePasswordForm />;
};

export default ChangePassword;
